var _path, _path2, _path3;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Deadline = function Deadline(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 2a1 1 0 0 1 1 1v1h1a3 3 0 0 1 3 3v3a1 1 0 0 1-1 1H5v7a1 1 0 0 0 1 1h4a1 1 0 1 1 0 2H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 2 0v1h6V3a1 1 0 0 1 1-1Zm2.707 4.293A1 1 0 0 1 19 7v2H5V7a1 1 0 0 1 1-1h1v1a1 1 0 0 0 2 0V6h6v1a1 1 0 1 0 2 0V6h1a1 1 0 0 1 .707.293Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M17.75 15.496a.75.75 0 0 0-1.5 0V17c0 .199.079.39.22.53l1 1a.75.75 0 1 0 1.06-1.06l-.78-.78v-1.194Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17 12a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Deadline;